import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import type { AuthTokens, SessionUser } from './types';

interface SessionState {
  user: SessionUser | null;
  tokens: AuthTokens | null;
  setSession: (user: SessionUser, tokens: AuthTokens) => void;
  setUser: (user: SessionUser) => void;
  clearSession: () => void;
}

export const useSessionStore = create<SessionState>()(
  persist(
    (set) => ({
      user: null,
      tokens: null,
      setSession: (user, tokens) => set({ user, tokens }),
      setUser: (user) => set({ user }),
      clearSession: () => set({ user: null, tokens: null }),
    }),
    {
      name: 'mydent-session',
      storage: createJSONStorage(() => localStorage),
      partialize: ({ user, tokens }) => ({ user, tokens }),
    },
  ),
);

export const useIsAuthenticated = () => useSessionStore((s) => !!s.tokens?.accessToken);
export const useSessionUser = () => useSessionStore((s) => s.user);
